<template>
  <div v-if="media.length" class="row pt-2">
    <template v-for="(data, key) in media" :key="key">
      <div v-if="data" class="col position-relative media-container">
        <div
          v-if="!data.id"
          class="d-flex align-items-center justify-content-center border position-relative media-element"
        >
          wurde bereits eingelesen
        </div>
        <div v-else class="d-flex align-items-center justify-content-center border position-relative media-element">
          <div
            v-if="!preservedMedia[key]"
            class="position-absolute top-0 left-0 start-0 end-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style="background-color: rgb(0, 0, 0, 0.4)"
          >
            <i class="bi bi-trash-fill text-white-50" style="font-size: 4rem"></i>
          </div>
          <img v-if="data.preview_url" :src="data.preview_url" :title="data.name" class="border mh-100 mw-100" />
          <span v-if="!data.preview_url" class="w-100 text-center position-absolute">
            <i class="bi bi-dash-circle text-warning" style="font-size: 4rem"></i>
          </span>
          <span
            v-if="preservedMedia[key]"
            class="position-absolute top-0 end-0 p-2 remove-icon"
            style="cursor: pointer; font-size: 1.5rem"
            @click="removeMedia(key)"
            :title="trans('models.media.hints.remove')"
          >
            <i class="bi bi-x-circle text-danger"></i>
          </span>
          <span
            v-if="!preservedMedia[key]"
            class="position-absolute top-0 end-0 p-2 restore-icon"
            style="cursor: pointer; font-size: 1.5rem"
            @click="restoreMedia(key)"
            :title="trans('models.media.hints.restore')"
          >
            <i class="bi bi-arrow-counterclockwise text-white-50"></i>
          </span>
          <span
            v-if="data.collection_name.substring(0, 9) === 'temporary' && preservedMedia[key]"
            class="position-absolute top-0 start-0 p-2 temporary-notice"
            style="font-size: 1.5rem"
            :title="trans('models.media.hints.unsaved')"
          >
            <i class="bi bi-exclamation-circle text-success"></i>
          </span>
        </div>
        <a :href="data.original_url" class="d-block border border-top-0 p-2 text-truncate" target="_blank">
          <i class="bi bi-paperclip"></i>
          <span :title="data.name">{{ data.name }}</span>
        </a>
      </div>
    </template>
  </div>
  <input
    :id="name"
    :class="{ 'is-invalid': errors }"
    :name="name"
    :placeholder="label"
    :required="required"
    :value="null"
    class="form-control"
    multiple
    type="file"
    @change="uploadTemporary($event)"
  />
</template>

<script>
import { onMounted, ref, watch } from 'vue';

export default {
  props: {
    errors: { type: Array, default: null },
    name: { type: String, default: 'media' },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    resource: { type: Object, default: null },
    media: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({ maxSize: '30 MB' }) }, // TODO: do somethign with this info. currently gets displayed in label
  },
  emits: ['update:data', 'update:media', 'update:model', 'update:toasts'],
  setup(props, { emit }) {
    const localMedia = ref(props.media);

    const preservedMedia = ref(props.media.map(() => true));

    const removeMedia = (key) => {
      preservedMedia.value[key] = false;
      localMedia.value[key].remove = true;
      emit('update:media', localMedia);
    };

    const restoreMedia = (key) => {
      preservedMedia.value[key] = true;
      localMedia.value[key].remove = false;
      emit('update:media', localMedia.value);
    };

    const uploadTemporary = async (event) => {
      let formData = new FormData();
      for (let i = 0; i < event.target.files.length; i++) {
        if (props.resource) {
          formData.append('resourceType', props.resource.meta.resourceType);
          formData.append('resourceId', props.resource.data.id);
        }
        formData.append(props.name + '[]', event.target.files[i]);
      }

      let response = await window.axios
        .post('/uploads', formData, {
          baseURL: window.axios.defaults.baseURL.slice(4),
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error.response) {
            switch (error.response.status) {
              case 413:
                emit('update:toasts', [
                  { type: 'error', message: window.Lang.get('validation.errors.FILE_TOO_LARGE') },
                ]);
                break;
            }
          } else {
            emit('update:toasts', [{ type: 'error', message: window.Lang.get('validation.errors.UNKNOWN_ERROR') }]);
          }
        });

      if (response) {
        for (let key in response.media) {
          localMedia.value.push(response.media[key]);
          preservedMedia.value.push(true);
        }
        if (response.model) {
          emit('update:model', response.model, response.relations ?? []);
        }
        emit('update:data', localMedia.value); // fixme
        emit('update:media', localMedia.value); // fixme
      }
    };

    onMounted(() => {
      watch(
        () => props.media,
        () => {
          localMedia.value = props.media;
        }
      );
    });

    return {
      localMedia,
      preservedMedia,
      removeMedia,
      restoreMedia,
      uploadTemporary,
    };
  },
};
</script>
